module.exports = __webpack_public_path__ + "img/business6.edc80750.png";